import useMd from '../custom-hooks/use-md';

const MdText = ({
  children,
  fontSize,
  alignment,
  color,
  fontWeight,
  fontFamily,
  margin,
  padding,
}) => {
  const md = useMd();

  return md(
    children,
    {
      fontSize,
      alignment,
      color,
      fontWeight,
      fontFamily,
      margin,
      padding,
    },
    alignment,
  );
};

export default MdText;
